export default "__VITE_ASSET__CVF3ufrf__"